/**
 * The "Échéances" tab (owner requests, 2026-10-03): the wines in stock past their window (the
 * badges' rule, FR-033), then those due within 24 months, counted in months from this month to
 * the due month; each soonest due date first.
 */
import type { Wine } from './cellar';
import { drinkByState, todayInParis, type CalendarDay } from './drink-by';

/** Due within this many months to be listed under "À boire d'ici 24 mois". */
export const EXPIRING_WITHIN_MONTHS = 24;

const dayKey = (day: CalendarDay | undefined) =>
  day ? day.year * 10_000 + day.month * 100 + day.day : 0;

const monthsBetween = (from: CalendarDay, to: CalendarDay) =>
  (to.year - from.year) * 12 + (to.month - from.month);

export function expiringWines(
  wines: readonly Wine[],
  today: CalendarDay = todayInParis(),
): { past: Wine[]; soon: Wine[] } {
  const entries = wines.map((wine) => ({ wine, state: drinkByState(wine, today) }));
  const byDue = (a: (typeof entries)[number], b: (typeof entries)[number]) =>
    dayKey(a.state.due) - dayKey(b.state.due);
  const past = entries.filter((entry) => entry.state.badge === 'past');
  const soon = entries.filter(
    ({ state }) =>
      state.due !== undefined &&
      state.badge !== 'past' &&
      monthsBetween(today, state.due) <= EXPIRING_WITHIN_MONTHS,
  );
  return {
    past: past.sort(byDue).map((entry) => entry.wine),
    soon: soon.sort(byDue).map((entry) => entry.wine),
  };
}
